import React, { useEffect, useRef, useState } from "react";
import { Download, Share2 } from "lucide-react";
import { toast } from "sonner";
import { drawStreakCard, downloadStreakCard } from "@/lib/streakCard";
import { track } from "@/lib/analytics";

/** Shown under the Guess-the-Year result: preview + download of the streak card, WhatsApp / X share. */
export const StreakShare = ({ result, streak, kind, dateLabel }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const opts = { score: result.score, streak, year: result.year, guess: result.guess, text: result.text, kind, dateLabel, revealed: !!result.revealed };
  useEffect(() => { if (ref.current) drawStreakCard(ref.current, opts); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [result.score, streak, result.year]);
  const url = `${window.location.origin}/#hall-of-fame`;
  const text = result.revealed
    ? `I peeked at today's OddlyTrue Guess the Year (${dateLabel}) — ${streak}-day streak still alive. Can you do better?`
    : `I scored +${result.score} on today's OddlyTrue Guess the Year (${dateLabel}) — ${streak}-day streak 🔥 Can you beat it?`;
  const share = (channel) => track("streak_share", { channel, score: result.score, streak, category: "share" });
  const download = async () => {
    setBusy(true);
    try { await downloadStreakCard(opts); share("download"); toast.success("Streak card downloaded"); }
    catch { toast.error("Could not build the card"); }
    finally { setBusy(false); }
  };
  const a = "inline-flex items-center h-8 px-3 rounded-full border border-ink/20 bg-white text-[12px] font-bold text-ink-muted hover:border-gold hover:text-gold transition-colors";
  return (
    <div data-testid="streak-share" className="mt-4 flex items-center gap-4 border-t border-ink/15 pt-4">
      <canvas ref={ref} data-testid="streak-card-preview" aria-label="Streak card preview" className="w-20 h-20 rounded-lg border border-ink/20 shrink-0" />
      <div className="min-w-0 flex-1">
        <p className="text-[11px] font-bold uppercase tracking-[0.15em] text-gold inline-flex items-center gap-1.5"><Share2 className="w-3.5 h-3.5" /> Share your streak</p>
        <div className="mt-2 flex flex-wrap gap-2">
          <button type="button" onClick={download} disabled={busy} data-testid="streak-download" className="inline-flex items-center gap-1.5 h-8 px-3 rounded-full bg-ink text-white text-[12px] font-bold hover:bg-gold hover:text-ink transition-colors disabled:opacity-60"><Download className="w-3.5 h-3.5" /> {busy ? "Building…" : "Card"}</button>
          <a href={`https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`} target="_blank" rel="noopener noreferrer" onClick={() => share("whatsapp")} data-testid="streak-whatsapp" className={a}>WhatsApp</a>
          <a href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`} target="_blank" rel="noopener noreferrer" onClick={() => share("x")} data-testid="streak-x" className={a}>X</a>
        </div>
      </div>
    </div>
  );
};
